import React from 'react'
import { Typography, Divider, Alert } from 'antd'
import PropTypes from 'prop-types'

import FilterBar from './components/FilterBar'
import DownloadsSection from './components/DownloadsSection'
import QualitySection from './components/QualitySection'
import TransactionsSection from './components/TransactionsSection'
import { formatPeriod } from './dateUtils'

const { Title, Text } = Typography

const UserQuality = ({
  applied,
  onApply,
  userStatistics,
  userLoading,
  userError,
  transactionStatistics,
  transactionLoading,
  transactionError,
  firstTimeBuyersOnly,
  onFirstTimeBuyersToggle,
  downloads,
  downloadsLoading,
  downloadsError
}) => (
  <div style={{ maxWidth: 1120 }}>
    <div style={{ marginBottom: 16 }}>
      <Title level={3} style={{ marginBottom: 0 }}>
        Статистика пользователей
      </Title>
      <Text type="secondary">Период: {formatPeriod(applied)}</Text>
    </div>

    <FilterBar applied={applied} onApply={onApply} />

    {(userError || transactionError) && (
      <Alert
        type="error"
        showIcon
        style={{ marginBottom: 16 }}
        message={`Ошибка загрузки статистики: ${
          (userError || transactionError).message
        }`}
      />
    )}

    <DownloadsSection
      data={downloads}
      loading={downloadsLoading}
      error={downloadsError}
    />

    <QualitySection stats={userStatistics} loading={userLoading} />

    <Divider />

    <TransactionsSection
      stats={transactionStatistics}
      loading={transactionLoading}
      firstTimeBuyersOnly={firstTimeBuyersOnly}
      onFirstTimeBuyersToggle={onFirstTimeBuyersToggle}
    />
  </div>
)

UserQuality.propTypes = {
  applied: PropTypes.object.isRequired,
  onApply: PropTypes.func.isRequired,
  userStatistics: PropTypes.object,
  userLoading: PropTypes.bool,
  userError: PropTypes.object,
  transactionStatistics: PropTypes.object,
  transactionLoading: PropTypes.bool,
  transactionError: PropTypes.object,
  firstTimeBuyersOnly: PropTypes.bool.isRequired,
  onFirstTimeBuyersToggle: PropTypes.func.isRequired,
  downloads: PropTypes.object,
  downloadsLoading: PropTypes.bool,
  downloadsError: PropTypes.string
}

export default UserQuality
